import React, { useState } from "react";
import { Input, Radio, RadioGroup } from "rsuite";

export function TravelInsurance({ data, onChange, errors }) {
  const [travelInsurance, setTravelInsurance] = useState(data?.travel_insurance);

  return (
    <>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Travel Insurance Details</h2>
        </div>
        <div className="card-body p-3 ">
          <label  style={{
            fontSize: 14,
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span>Do you require Trip Merchant to assist you with purchasing travel insurance?</span>
            {errors?.travel_insurance && (
              <span style={{ color: 'red', fontSize: 13 }}>
      {errors?.travel_insurance}
    </span>
            )}
          </label>
          <RadioGroup
            name="insurance"
            onChange={(value) => {
              if (value == "Yes") {
                setTravelInsurance("Yes");
                onChange("travel_insurance", "Yes");
              } else {

                setTravelInsurance("No");
                onChange("travel_insurance", 'No');
              }
            }}
            // onChange={(value) => onChange("travel_insurance", value)}
            defaultValue={
              data?.travel_insurance ? data?.travel_insurance : null
            } // Set the default value to 'No' or 'Yes' based on your requirement
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="No">No</Radio>
          </RadioGroup>

          {travelInsurance == "No" && (
            <Input
              className="mb-2"
              title={"please provide insurance provider"}
              label={"please provide insurance provider"}
              placeholder={"Please provide insurance provider"}
              type={"text"}
              onChange={(value) => onChange("travel_insurance", value)}
            />
          )}
        </div>
      </div>
    </>
  );
}
